import React from 'react'
import Navbar from './Navbar'
import Title from './Title'

function Header() {
    return (
        <div id="main">
            <Navbar/>
            <Title/>
        </div>
    )
}

export default Header
